import Vue from 'vue'
import Router from '../utils/router'
import ImprintStyle from '../views/ImprintStyle.vue'
import Content from '../views/Content.vue'
import Art from '../views/Art.vue'
import Items from '../views/Items.vue'

Vue.use(Router)

let states = window.RB.layout.manifest.states

let allRoutes = [
  {
    path: '/imprint-style',
    name: 'bandbuilder.silicone.imprint',
    component: ImprintStyle
  },
  {
    path: '/content',
    name: 'bandbuilder.silicone.text',
    component: Content
  },
  {
    path: '/art',
    name: 'bandbuilder.silicone.graphics',
    component: Art
  },
  {
    path: '/items',
    name: 'bandbuilder.silicone.style',
    component: Items
  }
]

let routes = allRoutes.filter((r) => {
  return states.find(s => s.state === r.name)
})

// catch all redirect
routes.push({ path: '*', redirect: { name: routes[0].name } })

const router = new Router({
  mode: 'hash',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'bandbuilder.silicone.style') {
    let signups = document.getElementsByClassName('signup-cont')
    if (signups.length > 0) {
      let signup = signups[0]
      signup.classList.add('hidden')
      signup.classList.add('d-none')
    }
  }
  if (from.name === 'bandbuilder.silicone.style') {
    let signups = document.getElementsByClassName('signup-cont')
    if (signups.length > 0) {
      let signup = signups[0]
      signup.classList.remove('hidden')
      signup.classList.remove('d-none')
    }
  }

  next()
})

export default router
